/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdatePortfolioCommand } from '../../models/update-portfolio-command';
import { UpdatePortfolioCommandResult } from '../../models/update-portfolio-command-result';

export interface ApiPortfolioUpdatePortfolioPatch$Plain$Params {
      body?: UpdatePortfolioCommand
}

export function apiPortfolioUpdatePortfolioPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiPortfolioUpdatePortfolioPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdatePortfolioCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPortfolioUpdatePortfolioPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdatePortfolioCommandResult>;
    })
  );
}

apiPortfolioUpdatePortfolioPatch$Plain.PATH = '/api/Portfolio/UpdatePortfolio';
